export default "__VITE_ASSET__3fecf037__"